import {Property} from "csstype";

export default function Spacer(props: {
    width?: Property.Width | undefined,
    height?: Property.Height | undefined
}) {
    return <div style={{ ...props }} />
}